<section class="table-row" [ngClass]="{'db-isSubdomain': cantRemoveDomain}">
  <div class="domain-title row-item">
    <a class="db-domain-title" target="_blank" rel="noopener"
       [dsTooltipPosition]="'right'"
       [dsTooltipSize]="'big'"
       [dsTooltipAlign]="'bottom'"
       [dsTooltipVisible]="domain?.name?.length > 30"
       [dsTooltip]="domainFull"
       [dsTooltipMode]="'hoverStatic'">
      {{ domain?.name | middleEllipsis: 30 }}</a>
    <ng-template #domainFull>
      <div class="db-copy-domain-title"
           ngxClipboard [cbContent]="domain?.name" (cbOnSuccess)="copied()"
           dsTooltipSize="xs" dsTooltipPosition="top"
           dsTooltipAlign="right"
           dsTooltipColor="black"
           [hostClass]="'cover-all'"
           [dsTooltip]="'<b>' + ((isCopied ? 'text_copied' : 'text_copy') | dbText) +'</b>'">
        <span>{{ domain?.name }}</span>
        <i class="db-icon db-icon-ds-copy ml8"></i></div>
    </ng-template>
    <span *ngIf="domain?.default" class="ds-primary-domain-label"
          [dsTooltip]="'text_primaryDomainTooltip' | dbText"
          [hostClass]="'cover-all'"
          dsTooltipFont="regular"
          dsTooltipSize="medium"
          dsTooltipColor="white"
          dsTooltipPosition="right"
          dsTooltipAlign="bottom">{{ 'text_primary' | dbText }}</span>
    <span *ngIf="cantRemoveDomain && !domain?.default" class="ds-subdomain-domain-label"
          [dsTooltip]="'text_subDomainDomainsTooltip' | dbText"
          [hostClass]="'cover-all'"
          dsTooltipFont="regular"
          dsTooltipSize="medium"
          dsTooltipColor="white"
          dsTooltipPosition="right"
          dsTooltipAlign="bottom">{{ 'text_installWebsiteDialogTitle' | dbText }}</span>
  </div>

  <div class="ds-domain-details-wrapper row-item">
    <div
      class="ds-domain-status" [ngClass]="{'db-checking': checkStatusesLoading}">
      <span *ngIf="!checkStatusesLoading"
            class="ds-status-dot {{domain?.domainPointed || cantRemoveDomain ? 'green': 'red'}} mr8"></span>
      <db-loading-circular-spinner *ngIf="checkStatusesLoading" [color]="'gray'" [size]="'xxs'"
                                   class="mr4"></db-loading-circular-spinner>
      {{
          (checkStatusesLoading ? 'text_checking' : cantRemoveDomain ? 'text_pointed' : domain?.domainPointed ?
          'text_pointed' :
          'text_notPointed') | dbText
      }}
    </div>
    <div class="ds-domain-details" [ngClass]="{'disabled': checkStatusesLoading}"
         *ngIf="(!cantRemoveDomain || domain?.verificationNeeded) && !isMainDomain()"
         (click)="checkDetails(domain?.domainPointed, domain?.tenWebDomain, domain?.tenWebNs, domain?.name, domain?.zone?.id)">
      <ng-container *ngIf="!domain?.pending;else pending">
        {{ (domain?.verificationNeeded ? 'text_verificationNeeded' : 'text_details') | dbText }}
      </ng-container>
      <ng-template #pending>
          {{ 'text_pending' | dbText }}
      </ng-template>
    </div>
  </div>

  <div class="db-actions">
    <div class="ds-manage-dns row-item" *ngIf="domain?.zone && !isMainDomain()"
         [ngClass]="{'disabled': primaryLoading || isPointedDomainLoading || buttonClicked || checkStatusesLoading,
           'db-only-item': !domain?.zone}"
         (click)="manageDns(domain?.zone.id)"
         [dsTooltip]="'text_manageDnsTooltip' | dbText"
         [hostClass]="'cover-all'"
         dsTooltipFont="regular"
         dsTooltipSize="medium"
         dsTooltipColor="white"
         dsTooltipPosition="right"
         dsTooltipAlign="bottom">{{ 'text_manageDNS' | dbText }}
    </div>
    <div class="ds-make-primary row-item" *ngIf="!domain?.verificationNeeded && !domain?.pending && !domain?.default"
         [ngClass]="{'db-two-items': domain?.zone && !isMainDomain(), 'disabled': primaryLoading || isPointedDomainLoading || buttonClicked || checkStatusesLoading}"
         (click)="confirmMakePrimary(domain?.name, domain?.id, domain?.connectedWebsiteId, domain?.isConnected)">
        {{ 'text_makePrimary' | dbText }}
    </div>
  </div>

  <div class="ds-domain-actions-wrapper row-item" *ngIf="!cantRemoveDomain && !domain?.default">
    <a [ngClass]="{'ds-disabled': checkStatusesLoading}"
       [dsTooltip]="actionsRef"
       dsTooltipMode="click"
       dsTooltipPosition="top"
       [dsTooltipSize]="'xs'"
       dsTooltipAlign="right">
      <i class="db-icon db-icon-ds-more-l"></i>
    </a>
  </div>

</section>

<ng-template #actionsRef>
  <div class="ds-domain-actions">
    <p (click)="confirmRemove(domain?.name, domain?.id)" *ngIf="!cantRemoveDomain"
       [innerHTML]="'text_remove' | dbText"></p>
  </div>
</ng-template>
